import { render, staticRenderFns } from "./DashboardStateDialog.vue?vue&type=template&id=b2f1c50c&"
import script from "./DashboardStateDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardStateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2f1c50c')) {
      api.createRecord('b2f1c50c', component.options)
    } else {
      api.reload('b2f1c50c', component.options)
    }
    module.hot.accept("./DashboardStateDialog.vue?vue&type=template&id=b2f1c50c&", function () {
      api.rerender('b2f1c50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/DashboardStateDialog.vue"
export default component.exports